module.exports = __webpack_public_path__ + "media/Solartag_color.199e5491.mp4";